export default function (_opt = {}, callback = function () { }) {
  var onWxJSBridgeReady = function () {
    //分享给好友
    WeixinJSBridge.on('menu:share:appmessage', function (res) {
      var opt = typeof _opt === 'function' ? _opt('menu:share:appmessage', res) : _opt;
      WeixinJSBridge.invoke('sendAppMessage', {
        appid: 'wx951bdcac522929b6',
        img_url: opt.imgUrl,
        img_width: opt.imgWidth,
        img_height: opt.imgHeight,
        link: opt.link,
        desc: opt.appmessageDesc,
        title: opt.appmessageTitle
      }, function (res) {
        callback(res)
      });
      return false;
    });

    //分享到朋友圈
    WeixinJSBridge.on('menu:share:timeline', function (res) {
      var opt = typeof _opt === 'function' ? _opt('menu:share:timeline', res) : _opt;
      WeixinJSBridge.invoke('shareTimeline', {
        appid: 'wx951bdcac522929b6',
        img_url: opt.imgUrl,
        img_width: opt.imgWidth,
        img_height: opt.imgHeight,
        link: opt.link,
        title: opt.timelineTitle,
        desc: opt.timelineTitle
      }, function (res) {
        callback(res)
      });
      return false;
    });

    // QQ
    WeixinJSBridge.on('menu:share:qq', function (res) {
      var opt = typeof _opt === 'function' ? _opt('menu:share:qq', res) : _opt;
      WeixinJSBridge.invoke("shareQQ", {
        desc: opt.appmessageDesc,
        title: opt.appmessageTitle,
        img_url: opt.imgUrl,
        link: opt.link,
      }, function (res) {
        callback(res)
      })
    })
    // 空间
    WeixinJSBridge.on('menu:share:QZone', function (res) {
      var opt = typeof _opt === 'function' ? _opt('menu:share:QZone', res) : _opt;
      WeixinJSBridge.invoke("shareQZone", {
        desc: opt.appmessageDesc,
        title: opt.appmessageTitle,
        img_url: opt.imgUrl,
        link: opt.link,
      }, function (res) {
        callback(res)
      })
    })

    WeixinJSBridge.on('menu:share:weibo', function (e) {
      alert('对不起，该页面不支持分享到腾讯微博！');
      return false;
    });
  };

  window.WeixinJSBridge ? onWxJSBridgeReady() : document.addEventListener('WeixinJSBridgeReady', function () {
    onWxJSBridgeReady();
  });
}
